import React from 'react'
import { localizer, changeLanguage } from '../../Translator'
import { TextFieldLoginStyled } from "../common/InputStyled"
import Button from '@material-ui/core/Button'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import InputAdornment from '@material-ui/core/InputAdornment'
import Container from '@material-ui/core/Container'
import { SnackbarCustom } from "../Utilities/SnackbarCustom"
import AuthCli from "../../sdk/AuthCli"

/**
 * Session initiation and status for a front-office user.
 */
export class ForgotPass extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

      // Login form field.
      userEmail: '',

      isLoading: false,
      severity: "info",
      message: null
    }

    // Set focus at first on e-mail field, and later on attempt failure.
    this.focusOnEmail = true
  }

  async componentDidMount() {
    var language = new URLSearchParams(this.props.location.search).get("culture")
    if (language !== null) {
      this.setState({ isLoading: true })
      await changeLanguage(language)

      // Force the whole app to refresh in the new language.
      var handler = this.props.onLanguageChange
      if (handler != null) handler(language)
    }
  }

  /**
     * Controlled fields refresh.
     */
  handleFieldChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState((prev) => ({
      [name]: value
    }))
  }


  /**
   * By pressing the button an email will be sent to the email entered
   */
  handleSendEmail = () => {
    this.setState({ isLoading: true })
   
    AuthCli.RequestPasswordRecovery(this.state.userEmail).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        this.setState({ message: localizer.HelpPasswordSend, severity: "success" })
      }
    })
    
    this.setState({ isLoading: false })
  }

  handleonClose = () => {
    this.setState({ message: null })
    if (this.state.severity === "success") window.location.href = 'login'
  }

  render() {
    const buttonEnabled = !this.state.isLoading && this.state.userEmail

    return (
      <React.Fragment>
        <Container maxWidth="xs" spacing={4} style={{ marginTop: 25, marginBottom: 75 }} >
          <Paper elevation={2} >
            <Grid container spacing={2} style={{ paddingLeft: 18, paddingRight: 18, paddingBottom: 12, paddingTop: 12 }}>

              {/* Title. */}
              <Grid item xs={12}>
                <Typography className="typography-generic dialog-title" gutterBottom >{localizer.HelpPassword}</Typography>
                <Typography className="typography-generic" gutterBottom >{localizer.ForgotPasswordInfo}</Typography>
              </Grid>
            
              {/* E-mail address. */}
              <Grid item xs={12}>
                <TextFieldLoginStyled
                  variant="outlined"
                  placeholder={localizer.Email}
                  name="userEmail"
                  value={this.state.userEmail}
                  onChange={(e) => { this.handleFieldChange(e) }}
                  fullWidth
                  inputRef={(input) => { if (input != null && this.focusOnEmail) { input.focus(); this.focusOnEmail = false } }}
                  InputProps={{
                    classes: {
                      input: "typography-generic"
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <i className="fa-solid fa-user"/>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
                        

              {/* Log in button. */}
              <Grid item xs={12}>
                <Button className="button-generic login"
                  variant="contained"
                  color="secondary"
                  fullWidth
                  disabled={!buttonEnabled}
                  onClick={this.handleSendEmail}>
                  {localizer.Send}
                </Button>
              </Grid>
            </Grid>
          </Paper>

          {/* Waiting for service response. */}
          {this.state.isLoading &&
            <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
              <CircularProgress color="secondary" />
            </Backdrop>
          }
        </Container>

        {/* Replace password message. */}
        <SnackbarCustom message={this.state.message} severity={this.state.severity} handleonClose={this.handleonClose} />
       
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/password/ForgotPass.js